import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import Formsy from 'formsy-react';
import { Typography, Grid, Button } from '@mui/material';
import FileInput from 'components/inputs/FileInput';
import { confirmUpload } from 'actions/OrderActions';

const requiredValidation = {isDefaultRequiredValue: "can't be blank"};

export class ConfirmationPage extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(data, _resetForm, _invalidateForm) {
    this.props.confirmUpload(_.merge(data, {reference_number: this.props.match.params.reference_number}));
  }

  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>

        <Grid container spacing={1} align='center'>
          <Grid size={{xs: 12}}>
            <Formsy onValidSubmit={this.handleSubmit} style={{width: '100%', marginTop: '8px'}}>
              <Grid container spacing={1} justify='center'>
                <Grid size={{xs: 12, md: 8}}>
                  <Typography>Please upload requested documents here</Typography>
                  <FileInput name='image_blob_key' buttonLabel='Choose File' required />
                </Grid>
              </Grid>
              <div className='button-container'>
                <Button type='submit' variant='contained' color='primary'>Confirm</Button>
              </div>
            </Formsy>
          </Grid>
        </Grid>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  confirmUpload: (data) => confirmUpload(data)
}

export default connect(null, mapDispatchToProps)(ConfirmationPage);
